import { SET_GROUP_PAGINATION } from "../ActionName/ActionName"

export const setGroupPagination = (data) => {
    return {
        type: SET_GROUP_PAGINATION,
        value: data
    }
}



